import type { TokenCookie } from '@/types/cookies';
import type { Nullable } from '@/types/utils';
import type { CookieRef } from '#app';

const COOKIE_NAME = 'token';

export const useCookieToken = (): CookieRef<Nullable<TokenCookie>> => {
  const cookie = useCookie<Nullable<TokenCookie>>(COOKIE_NAME, {
    path: '/',
    maxAge: ONE_YEAR,
    secure: !import.meta.dev,
  });

  return computed({
    get: () => cookie.value,
    set(newValue) {
      cookie.value = newValue;

      if (import.meta.server) {
        updateServerCookie(useRequestEvent(useNuxtApp()), COOKIE_NAME, cookie.value);
      }
    },
  });
};
